module.exports = "/hwa/_next/static/images/rubble-b96ec5ef6269eca2214ece70610a6f2f.png";